<template>
    <div v-if="isLoaded">
        <rkm-data-table
            :fields="fields"
            :repository="repositories.obito"
            ref="RkmDataTable"
            sort-by="nome"
        >
            <template v-slot:cell(cns)="{item}">
                {{formatCns(item.cns)}}
            </template>

            <template v-slot:cell(actions)="{item}">
                <rkm-button
                    @click="edit(item.id)"
                    authorize="create-cadastro-obito"
                    color="primary"
                    small
                    title="Editar"
                >
                    <rkm-icon icon="pen" />
                </rkm-button>

                <rkm-button
                    @click="destroy(item)"
                    authorize="destroy-cadastro-obito"
                    color="danger"
                    small
                    title="Excluir"
                >
                    <rkm-icon icon="trash" />
                </rkm-button>
            </template>
        </rkm-data-table>

        <Modal
            ref="Modal"
            @handleSupervisorEditar="handleSupervisorEditar"
        />
    </div>
</template>

<script>
// Components.
import Modal from '@/components/cadastro/obito/Modal'

// Mixins.
import {error, formats, repository} from '@/mixins'

export default {
    components: { Modal },
    created() {
        this.repositories = {
            obito: this.getConectaSusRepository('cadastro.obito'),
        }

        this.isLoaded = true
    },
    data: () => ({
        isLoaded: false,
        supervisorId: null,
        obitoId: null,
        fields: [
            {key: 'nome', label: 'Nome', name: 'cadastroCidadao.nome', searchable: true, sortable: true},
            {key: 'cns', label: 'CNS', name: 'cadastroCidadao.cns', searchable: true, sortable: true},
            {key: 'obitoEm', label: 'Data do óbito', name: 'cadastroObito.obitoEm', searchable: true, sortable: true},
            {key: 'declaracao', label: 'Declaração', name: 'cadastroObito.declaracao', searchable: true, sortable: true},
            {class: 'col-min', key: 'actions', label: 'Ações', name: 'actions'},
        ],
    }),
    methods: {
        handleSupervisorEditar(supervisorId){

            this.supervisorId = supervisorId
            const id = this.obitoId

            this.$router.push({name: 'cadastro-obito-edit', params: {id}})
        },
        edit(id) {

            this.obitoId = id

            if (!this.supervisorId) {

                const cancel = async () => {

                    await this.$refs.Modal.cancel()
                }
                
                const confirm = async () => {

                    await this.$refs.Modal.open()
                }

                const msg = `Para continuar é necessário informar os dados do supervisor. Deseja continuar?`

                this.showConfirmation(msg, confirm, cancel)

                return
            }
        },
        destroy(item) {
            const destroy = () => this.repositories.obito.destroy(item.id)
                .then(() => this.$refs.RkmDataTable.refresh())

            this.showDeleteConfirmation('Deseja realmente excluir o óbito?', destroy)
        },
    },
    mixins: [error, formats, repository],
}
</script>